var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import PlusCircleSvg from './plus-circle.icon.svg';
export const PlusCircleIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: PlusCircleSvg }));
_react_refresh_temp_1 = PlusCircleIcon;
$RefreshReg$(_react_refresh_temp_1, "PlusCircleIcon");
